// Единые перечисления для API, бота и портала.
// Значения совпадают с enum-типами в PostgreSQL (apps/api/src/db/schema.ts).

export const USER_ROLES = ["logist", "admin"] as const;
export type UserRole = (typeof USER_ROLES)[number];

export const LOT_STATUSES = [
  "draft",
  "active",
  "awaiting_winner_data",
  "formalized_pre_trip",
  "delivered",
  "closed",
  "paid",
  "no_winner",
  "cancelled",
] as const;
export type LotStatus = (typeof LOT_STATUSES)[number];

export const LOT_STATUS_LABELS: Record<LotStatus, string> = {
  draft: "Черновик",
  active: "Активна",
  awaiting_winner_data: "Завершена — ожидает данные",
  formalized_pre_trip: "В рейсе",
  delivered: "Доставлено — проверка документов",
  closed: "Доставка подтверждена — к оплате",
  paid: "Оплачено",
  no_winner: "Без победителя",
  cancelled: "Отменена",
};

export const TRANSPORT_KINDS = ["domestic", "international"] as const;
export type TransportKind = (typeof TRANSPORT_KINDS)[number];

export const TRANSPORT_KIND_LABELS: Record<TransportKind, string> = {
  domestic: "По Казахстану",
  international: "Международная",
};

/** НДС определяется типом перевозки: по РК — с НДС, международная — без. */
export const vatLabel = (kind: TransportKind): string =>
  kind === "domestic" ? "с НДС" : "без НДС";

export const BID_RESULTS = [
  "accepted",
  "rejected_step",
  "rejected_leader",
  "rejected_deadline",
  "rejected_race",
  "rejected_status",
] as const;
export type BidResult = (typeof BID_RESULTS)[number];

export const FINISH_REASONS = ["deadline", "early", "cancelled"] as const;
export type FinishReason = (typeof FINISH_REASONS)[number];

export const LOT_EVENT_TYPES = [
  "created",
  "edited",
  "published",
  "bid_accepted",
  "extended_manual",
  "extended_auto",
  "finished_deadline",
  "finished_early",
  "cancelled",
  "winner_data_received",
  "formalized_pre_trip",
  "post_trip_requested",
  "closed",
  "delivery_reported",
  "delivery_confirmed",
  "paid",
  "delivery_fix_requested",
] as const;
export type LotEventType = (typeof LOT_EVENT_TYPES)[number];

export const WINNER_STAGES = ["pre_trip", "post_trip", "closed"] as const;
export type WinnerStage = (typeof WINNER_STAGES)[number];

export const WINNER_DOC_TYPES = [
  "driver_id",
  "tech_passport",
  "border_pass",
  "cmr",
  "avr",
  "invoice",
  "other",
] as const;
export type WinnerDocType = (typeof WINNER_DOC_TYPES)[number];

export const WINNER_DOC_LABELS: Record<WinnerDocType, string> = {
  driver_id: "Удостоверение личности / паспорт водителя",
  tech_passport: "Техпаспорт автомобиля",
  border_pass: "Талон прохождения границы",
  cmr: "СМР (CMR)",
  avr: "АВР (акт выполненных работ)",
  invoice: "Счёт на оплату",
  other: "Другое",
};

/** Этап, к которому относится документ победителя: до рейса или доказательства доставки (раздел 14). */
export const WINNER_DOC_STAGES = ["pre_trip", "delivery"] as const;
export type WinnerDocStage = (typeof WINNER_DOC_STAGES)[number];

export const WINNER_DOC_STAGE_LABELS: Record<WinnerDocStage, string> = {
  pre_trip: "до рейса",
  delivery: "доставка",
};

export const DOC_SOURCES = ["telegram", "portal"] as const;
export type DocSource = (typeof DOC_SOURCES)[number];

export const DELIVERY_STATUSES = ["pending", "sent", "failed", "blocked"] as const;
export type DeliveryStatus = (typeof DELIVERY_STATUSES)[number];

export const LOT_EVENT_LABELS: Record<LotEventType, string> = {
  created: "Заявка создана",
  edited: "Заявка изменена",
  published: "Опубликована, разослана перевозчикам",
  bid_accepted: "Принята ставка",
  extended_manual: "Продлена логистом",
  extended_auto: "Автопродление",
  finished_deadline: "Торги завершены по дедлайну",
  finished_early: "Торги завершены досрочно",
  cancelled: "Отменена",
  winner_data_received: "Получены данные победителя",
  formalized_pre_trip: "Оформлена — до рейса",
  post_trip_requested: "Запрошены закрывающие документы",
  closed: "Доставка подтверждена — к оплате",
  delivery_reported: "Перевозчик сообщил о доставке",
  delivery_confirmed: "Доставка подтверждена логистом",
  paid: "Оплачено",
  delivery_fix_requested: "Запрошены недостающие документы",
};

export const WINNER_STAGE_LABELS: Record<WinnerStage, string> = {
  pre_trip: "До рейса",
  post_trip: "После рейса",
  closed: "Закрыта",
};

export const DOC_SOURCE_LABELS: Record<DocSource, string> = {
  telegram: "из Telegram",
  portal: "загрузил логист",
};

export const DELIVERY_STATUS_LABELS: Record<DeliveryStatus, string> = {
  pending: "ожидает отправки",
  sent: "доставлено",
  failed: "ошибка доставки",
  blocked: "бот заблокирован",
};

/** Результат попытки ставки — для админки (раздел 9 требований). */
export const BID_RESULT_LABELS: Record<BidResult, string> = {
  accepted: "принята",
  rejected_step: "отклонена: меньше шага",
  rejected_leader: "отклонена: уже лидер",
  rejected_deadline: "отклонена: после дедлайна",
  rejected_race: "отклонена: гонка",
  rejected_status: "отклонена: торги не ведутся",
};
